// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_JZL","inner":"Footer_inner__2xXwh","nextIcon":"Footer_nextIcon__2kF1w","innerLeft":"Footer_innerLeft__2FAc0"};